import { makeStyles } from '@mui/styles';
import { CustomTheme } from 'types/theme';

export const useStyles = makeStyles((theme: CustomTheme) => ({
  subtitle: {
    '&.MuiTypography-root': {
      fontSize: 16,
      textAlign: 'left',
      fontWeight: 600,
      color: '#28282A',
      marginTop: 20
    }
  },
  lastUpdate: {
    '&.MuiTypography-root': {
      fontSize: 16,
      fontWeight: 400,
      color: 'rgba(0, 0, 0, 0.6)',
      marginTop: 8,
      marginBottom: 10
    }
  },
  checkbox: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 20,
    marginBottom: 20,
    gap: 12
  },
  button: {
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      maxWidth: 150
    }
  },
  input: {
    width: 18,
    height: 18
  }
}));
